export enum ProdPartsActionTypes {
  success = '[Lane] [ProdParts] Fetch success',
  fail = '[Lane] [ProdParts] Fetch fail',
  waiting = '[Lane] [ProdParts] Fetch waiting...',
}
